export const CampaignPromisePackings = {
    sov: 'sov',
    sovd: 'sovd',
    vac: 'vac',
    sfi: 'sfi',
    fxp: 'fxp',
    fxa: 'fxa',
    fxi: 'fxi',
    flexai: 'flexai',
    sovp: 'sovp'
}

export const Countries = {
    se: 'se',
    no: 'no',
    dk: 'dk'
}